var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 21.125 21.1358",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.67547 10.3421C1.63957 10.378 1.625 10.4191 1.625 10.4542V14.0292C1.625 14.6529 2.13873 15.1667 2.76249 15.1667H4.17079C4.26374 15.1667 4.33336 15.0971 4.33336 15.0042V10.4542C4.33336 10.3662 4.25789 10.2917 4.17079 10.2917H1.78753C1.75248 10.2917 1.71135 10.3062 1.67547 10.3421ZM0 10.4542C0 9.47457 0.807996 8.66668 1.78753 8.66668H4.17079C5.16705 8.66668 5.95836 9.48042 5.95836 10.4542V15.0042C5.95836 15.9946 5.1612 16.7917 4.17079 16.7917H2.76249C1.24125 16.7917 0 15.5504 0 14.0292V10.4542Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5625 1.625C6.81876 1.625 3.79166 4.65209 3.79166 8.39583V9.48997C3.79166 9.93873 3.4279 10.3025 2.97916 10.3025C2.53044 10.3025 2.16666 9.93873 2.16666 9.48997V8.39583C2.16666 3.7546 5.92124 0 10.5625 0C15.2038 0 18.9584 3.7546 18.9584 8.39583V9.47918C18.9584 9.92788 18.5945 10.2917 18.1459 10.2917C17.6971 10.2917 17.3334 9.92788 17.3334 9.47918V8.39583C17.3334 4.65209 14.3062 1.625 10.5625 1.625Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1975 15.1826C18.6375 15.2709 18.9225 15.6992 18.8341 16.1391C18.261 18.9921 15.7453 21.1358 12.7291 21.1358H11.6459C11.1971 21.1358 10.8334 20.7721 10.8334 20.3233C10.8334 19.8746 11.1971 19.5108 11.6459 19.5108H12.7291C14.9564 19.5108 16.8174 17.9278 17.2409 15.8192C17.3293 15.3792 17.7576 15.0942 18.1975 15.1826Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8421 10.3421C16.8063 10.378 16.7916 10.4191 16.7916 10.4542V15.0042C16.7916 15.0921 16.8671 15.1667 16.9542 15.1667H18.3084C18.9646 15.1667 19.5 14.6313 19.5 13.975V10.4542C19.5 10.3662 19.4246 10.2917 19.3375 10.2917H16.9542C16.9192 10.2917 16.878 10.3062 16.8421 10.3421ZM15.1666 10.4542C15.1666 9.47457 15.9747 8.66668 16.9542 8.66668H19.3375C20.3337 8.66668 21.125 9.48042 21.125 10.4542V13.975C21.125 15.5287 19.8621 16.7917 18.3084 16.7917H16.9542C15.958 16.7917 15.1666 15.9779 15.1666 15.0042V10.4542Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeadset);
export default __webpack_public_path__ + "static/media/icon-headset.32f3348c6f5cc11faff35cbe1cec6247.svg";
export { ForwardRef as ReactComponent };